import type { FaireProductEntity } from "../../entity_types/product";

export const p_zpx8jkp8mr: FaireProductEntity = {
  token: "p_zpx8jkp8mr",
  type: "product",
  name: "Gardner Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/bb20d6650befc05cf142f0e79b326e40548df46124407a7a23c70e726760fe04.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1e8a16b9208bb87dcbd01c67d82af2bfcf8226f58c8e187966ffd9ffef7c633.jpeg",
    "https://cdn.faire.com/fastly/02717d5e703264f653b15f7c50b54d6f8c1c09b14f6d6fd72c0a2b1256d3a4b8.jpeg"
  ],
  priceDollars: 8,
  description: "A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be \"well-edited\" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:43.090Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
